import React from 'react';
import { Text, StyleSheet, View } from 'react-native';
import Theme  from '../../theme';
import { scaleText } from '../../utils/scaling';

const HeaderTitle = ({ title, customTextSt={} }) => (
  <View style={styles.container}>
    <Text style={[styles.headerTitleStyle, customTextSt]}>
      {title}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitleStyle: {
    ...Theme.textStyle.bodyCopyBold,
    justifyContent: 'center',
    alignItems: 'center',
    color: Theme.GREY_DARK,
    textAlign: 'center',
    alignSelf: 'center',
    fontSize: scaleText(14),
  },
});

export default HeaderTitle;
